var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFeatherUploadWhite = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84.227,
    viewBox: "0 0 84 84.227",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill-opacity:0;fill:none;stroke:#ffffff;stroke-linecap:round;stroke-width:6px;}.b{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.245 -0.257)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M82.059,22.434l-.084,25.717H4.5V22.5h0",
    transform: "translate(0 33.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M53.278,25.889,31.889,4.5,10.5,25.889",
    transform: "translate(11.111 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18,4.5V55.833",
    transform: "translate(25 0)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFeatherUploadWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/feather-upload-white.dff5580e.svg";
export { ForwardRef as ReactComponent };